module.exports = __webpack_public_path__ + "static/media/save-disabled.71860307.svg";